import React, { useState } from 'react';
import Modal from '@app/components/General/Modal'
import Label from '@app/components/General/Label'
import { Button, Row, Col, Input, Select, message } from 'antd';
import {update, getById} from '../../../../apis/UsersApi';
import { getAll as getRoles } from '../../../../apis/RolesApi';

const { confirm } = Modal;
const EditUser = ({id, saveFn, closeFn, deleteFn}) => {
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState(1);
    const [roles, setRoles] = useState([]);
    const [_open, setOpen] = useState(false);

    const effectRan = React.useRef(false);
    React.useEffect(() => {
      if (!effectRan.current) {
        if(!id){return;}
        (async ()=>{
            const [response, rolesResponse] = await Promise.all([getById(id), getRoles()]);
            if(rolesResponse?.ok && rolesResponse?.payload){
                const options = rolesResponse.payload
                    .filter((item) => item?.id > 0)
                    .map((item) => ({ value: item.id, label: item.name }))
                    .sort((a, b) => a.value - b.value);
                setRoles(options);
            }
            if(response.ok){
                let user = response.payload;
                setEmail(user.email);
                setFirstName(user.first_name);
                setLastName(user.last_name);
                setRole(user.role_id || user.role || 1);
                setOpen(true);
            }
        })();
      }
      return () => effectRan.current = true;
    }, []);

    React.useEffect(() => {
       
    }, [id]);

    if(!id || id <= 0) return <></>;
    if(!_open) return <></>

    const handleOk = async () => {
        const payload = {
            first_name: firstName,
            last_name: lastName,
            email,
            role_id: role
        }

        const response = await update(id, payload);
        if(response.ok){
            message.success('Se guardo correctamente el usuario!');
        }
        if(saveFn){
            await saveFn(response);
        }
    }

    const handleChangeRole = (value) => {
        setRole(value);
    }

    return _open && <Modal open={true} closeFn={closeFn} title="Editar Usuario" buttons={[
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Guardar
                </Button>,
                <Button key="submit" type="primary" danger  loading={loading} onClick={()=>{deleteFn({id})}}>
                    Eliminar
                </Button>,
            ]}>
         <Row>
            <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                <Label>Correo Electrónico</Label>
                <Input value={email} defaultValue={email} onChange={(event)=>{setEmail(event.target.value)}} size="middle"/>
            </Col>
            <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                <Label>Nombre</Label>
                <Input value={firstName} defaultValue={firstName} onChange={(event)=>{setFirstName(event.target.value)}} size="middle"/>
            </Col>
            <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                <Label>Apellidos</Label>
                <Input value={lastName} defaultValue={lastName} onChange={(event)=>{setLastName(event.target.value)}} size="middle"/>
            </Col>

            <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                <Label>Rol</Label>
                <Select
                    style={{minWidth: 200}}
                    value={role}
                    onChange={handleChangeRole}
                    options={roles}
                    placeholder="Selecciona un rol"
                />
            </Col>
        </Row>
    </Modal>
}
export default EditUser;
